// src/components/admin/flows/components/EmptyState.js
import React from 'react';
import { GitBranch } from 'lucide-react';
import { useTheme } from '../../../../contexts/ThemeContext';

const EmptyState = ({
    icon: Icon = GitBranch,
    title = 'No workflows yet',
    description = 'Create your first workflow to get started',
    actionLabel,
    onAction,
}) => {
    const { theme } = useTheme();
    const isDark = theme === 'dark';

    return (
        <div className={`flex flex-col items-center justify-center py-16 px-4 rounded-xl border-2 border-dashed ${
            isDark ? 'border-gray-700 bg-gray-800/30' : 'border-gray-200 bg-gray-50/50'
        }`}>
            <div className={`p-4 rounded-full mb-4 ${isDark ? 'bg-gray-700' : 'bg-gray-100'}`}>
                <Icon className={`w-8 h-8 ${isDark ? 'text-gray-400' : 'text-gray-400'}`} />
            </div>
            <h3 className={`text-lg font-semibold mb-1 ${isDark ? 'text-white' : 'text-gray-900'}`}>
                {title}
            </h3>
            <p className={`text-sm mb-6 max-w-sm text-center ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                {description}
            </p>
            {actionLabel && onAction && (
                <button
                    onClick={onAction}
                    className="px-4 py-2 bg-blue-500 text-white rounded-lg text-sm font-medium hover:bg-blue-600 transition-colors"
                >
                    {actionLabel}
                </button>
            )}
        </div>
    );
};

export default EmptyState;
